import { api } from 'app/config/apiConfig';

import { Box, BoxDeactivationReason } from '../model/types';

export const deactivateBoxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deactivateBox: builder.mutation<Box, { boxId: string; deactivationReason: BoxDeactivationReason }>({
      query: (data) => ({
        url: `/boxes/${data.boxId}/deactivate`,
        method: 'PUT',
        body: { deactivationReason: data.deactivationReason },
      }),
      invalidatesTags: ['Boxes', 'Available boxes', 'Warehouses for booking'],
    }),
  }),
});

export const { useDeactivateBoxMutation } = deactivateBoxApi;
